import { Component } from '../../../libs/gin-tonic/helpers/compiler';
import { ProductStock } from './index';

@Component({ className: 'js-product-stock' })
export class ProductStockComponent {
	constructor(element: HTMLElement) {
		new ProductStock(element);
	}
}
